import CourseDropdown from "../Common/Component/CourseDropdown";
import FeeAmountColumn from "../Components/pages-partial/FeeManagement/FeeAmountColumn";
import { STUDENT_COURSE_CHANGE } from "../Constant";
import FeeAction from '../Components/pages-partial/FeeManagement/FeeAction'
import { getFeeDate, getFeeStatus } from "./fee";
import { Loader } from "react-feather";
import { Btn } from "../AbstractElements";

export const getFeeColumn = (module, transferStudentCourse, transferFirstModule, courseLoading, updateStudents, courseStudents, setTotal, feeAmount, setFeeAmount, activeCourse, moduleLoading) => {

  const feeStatus = (data, status) => {
    return getFeeStatus(data.courses[data.courseIndex].feeScreenshots, module, status) && <div className={`fee-status ${status}`} />
  }

  const notVerifiedSorter = (a, b, sortOrder) => {
    const statusA = a.courses[a.courseIndex].feeScreenshots[module]?.status;
    const statusB = b.courses[b.courseIndex].feeScreenshots[module]?.status;

    if (statusA === "notVerified" && statusB !== "notVerified") {
      return sortOrder === "asc" ? -1 : 1;
    } else if (statusA !== "notVerified" && statusB === "notVerified") {
      return sortOrder === "asc" ? 1 : -1;
    }

    // Add additional comparison logic if needed
    return 0;
  };

  const feeDate = (data) => {
    return getFeeDate(data.courses[data.courseIndex].feeScreenshots, module)
  }

  const data = [
    {
      title: "STUDENT ID",
      dataIndex: "studentId",
      fixed: "left",
    },
    {
      title: "NAME",
      dataIndex: "fullName",
      fixed: "left",
      sorter: (a, b) => {
        const valueA = a.fullName;
        const valueB = b.fullName;
        return valueA.localeCompare(valueB)
      }
    },
    {
      title: "EMAIL",
      dataIndex: "email",
      fixed: "left",
      sorter: (a, b) => {
        const valueA = a.email;
        const valueB = b.email;
        return valueA.localeCompare(valueB)
      },
    },
    {
      title: "NUMBER",
      dataIndex: "contactNo",
    },
    {
      title: "FEE UPLOAD DATE",
      render: (data) => feeDate(data),
      sorter: (a, b) => {
        const aFeeScreenshot = a.courses[a.courseIndex].feeScreenshots
        const afeeDate = aFeeScreenshot[module]?.date?.seconds ?  aFeeScreenshot[module]?.date?.seconds * 1000 : new Date()
        const bFeeScreenshot = b.courses[b.courseIndex].feeScreenshots
        const bfeeDate = bFeeScreenshot[module]?.date?.seconds ? bFeeScreenshot[module]?.date?.seconds * 1000 : new Date()
        return new Date(afeeDate ?? '') - new Date(bfeeDate ?? '')
      },

    },
    {
      title: "PENDING",
      render: (data) => feeStatus(data, 'pending'),
      sorter: (a, b) => {
        const aStatus = getFeeStatus(a.courses[a.courseIndex].feeScreenshots, module, 'pending')
        const bStatus = getFeeStatus(b.courses[b.courseIndex].feeScreenshots, module, 'pending')
        return (aStatus ? 1 : -1) - (bStatus ? 1 : -1)
      },

    },
    {
      title: "VERIFIED",
      render: (data) => feeStatus(data, 'verified'),
      sorter: (a, b) => {
        const aStatus = getFeeStatus(a.courses[a.courseIndex].feeScreenshots, module, 'verified')
        const bStatus = getFeeStatus(b.courses[b.courseIndex].feeScreenshots, module, 'verified')
        return (aStatus ? 1 : -1) - (bStatus ? 1 : -1)
      },
    },
    {
      title: "NOT VERIFIED",
      render: (data) => feeStatus(data, 'notVerified'),
      sorter: (a, b) => {
        const aStatus = getFeeStatus(a.courses[a.courseIndex].feeScreenshots, module, 'notVerified')
        const bStatus = getFeeStatus(b.courses[b.courseIndex].feeScreenshots, module, 'notVerified')
        return (aStatus ? 1 : -1) - (bStatus ? 1 : -1)
      },

    },
    {
      title: "FEE REFUND",
      render: (data) => feeStatus(data, 'refunded')
    },
    {
      title: "FEES AMOUNT",
      render: (data) => <FeeAmountColumn
        amount={feeAmount}
        setAmount={setFeeAmount}
        setTotal={setTotal}
        data={data}
        updateStudents={updateStudents}
        courseStudents={courseStudents}
        module={module}
      />,
      sorter: (a, b) => {
        const amountA = a.courses[a.courseIndex]?.feeScreenshots[module]?.feeAmount ?? 0
        const amountB = b.courses[a.courseIndex]?.feeScreenshots[module]?.feeAmount ?? 0
        return amountA - amountB;
      }
    },
    {
      title: "CHANGE COURSE",
      render: (data) =>
        <div className='table-course-select w-100 d-flex justify-content-center align-items-center'>
          {(courseLoading.loading && courseLoading.data.email === data.email) ? <Loader className="custom-spin" /> :
            <CourseDropdown
              onChangeCourse={transferStudentCourse}
              data={data}
              module={module}
              type={STUDENT_COURSE_CHANGE}
              courseId={data.courses[data.courseIndex].courseId}
            />
          }
        </div>
    },
    {
      title: 'TRANSFER MODULE',
      render: (data) => {
        const isHalfCourseSpent = Date.now() >= new Date(activeCourse.startDate).getTime() + (new Date(activeCourse.endDate) - new Date(activeCourse.startDate)) / 2;

        const hasBothModulesPaid = data.courses[data.courseIndex].feeScreenshots[0]?.status === 'verified' && data.courses[data.courseIndex].feeScreenshots[1]?.status === 'verified';

        const isModuleOneEnded = hasBothModulesPaid && isHalfCourseSpent;
        const isModuleOneSkipped = data.courses[data.courseIndex].feeScreenshots[0]?.skipModule;

        const isModuleZeroBlocked = !hasBothModulesPaid && (module === 0 && !isModuleOneEnded && !isModuleOneSkipped);
        const isModuleOneBlocked = (module === 1) && isModuleOneSkipped;

        return (isModuleZeroBlocked || isModuleOneBlocked) ? (
          <div className='table-course-select w-100 d-flex justify-content-center align-items-center'>
            {(moduleLoading.loading && moduleLoading.data.email === data.email) ? <Loader className="custom-spin" />:
              <Btn attrBtn={{
                onClick: () => transferFirstModule(data),
                color: "primary",
              }}>
                Transfer
              </Btn>
            }
          </div>
        ) : null
      }
    },
    {
      title: "ACTION",
      render: (data) => <FeeAction setTotal={setTotal} module={module} data={data} updateStudents={updateStudents} courseStudents={courseStudents} />
    }]

  return data
}

export const getFeeDataColumn = () => {
  return [
    {
      title: "VERIFIED",
      dataIndex: "verified",
    },
    {
      title: "REJECTED",
      dataIndex: "rejected",
    },
    {
      title: "PENDING",
      dataIndex: "pending",
    },
    {
      title: "UNPAID",
      dataIndex: "unpaid",
    },
    {
      title: "TOTAL WITH SCREENSHOT",
      dataIndex: "totalWithScreenshot",
    },
    {
      title: "TOTAL",
      dataIndex: "total",
    },
    {
      title: "REFUND",
      dataIndex: "refundAmount",
    },
    {
      title: "AMOUNT",
      dataIndex: "totalAmount",
    },
  ]
}

